import { render, staticRenderFns } from "./DeedDocument.handler.vue?vue&type=template&id=4610f1e8&"
import script from "./DeedDocument.handler.vue?vue&type=script&lang=ts&"
export * from "./DeedDocument.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports